export default "__VITE_ASSET__d434c245__"